import { preloadableRoute } from "./preloadable-route";

const Layouts = preloadableRoute(() => import("@/layouts"));
const Login = preloadableRoute(() => import("@/views/login"));
const Register = preloadableRoute(() => import("@/views/register"));
const Application = preloadableRoute(() => import("@/views/application"));

const Home = preloadableRoute(() => import("@/views/home"));
// const CompanyList = preloadableRoute(() => import("@/views/company-list"));
// const CompanyDetail = preloadableRoute(() => import("@/views/company-detail"));
const ProductIntro = preloadableRoute(() => import("@/views/product-intro"));
const ServiceIntro = preloadableRoute(() => import("@/views/service-intro"));
const Pricing = preloadableRoute(() => import("@/views/pricing"));
const News = preloadableRoute(() => import("@/views/news"));
const NewsDetail = preloadableRoute(() => import("@/views/news-detail"));
const NewsDetailLegacyRedirect = preloadableRoute(() => import("@/views/news-detail/legacy-redirect"));
const AboutUs = preloadableRoute(() => import("@/views/about-us"));

const Insights = preloadableRoute(() => import("@/views/insights"));
const InsightDetail = preloadableRoute(() => import("@/views/insight-detail"));
const FAQ = preloadableRoute(() => import("@/views/faq"));
const Privacy = preloadableRoute(() => import("@/views/privacy"));
const NotAllowed = preloadableRoute(() => import("@/views/components/error/not-allowed"));
const NotFound = preloadableRoute(() => import("@/views/components/error/not-found"));

const routes = [
	{
		path: "/",
		element: <Layouts />,
		children: [
			// 根路径直接渲染 Home，不再客户端跳转到 /home。
			// 跳转会让 react-snap 抓不到首页的 canonical，且 hydration 后也补不回来。
			{
				index: true,
				element: <Home />,
			},
			// /home 保留：站内既有链接、用户书签、已收录的 URL 都还指向它。
			// canonical 统一规范到根路径，两者不构成重复内容。
			{
				path: "home",
				element: <Home />,
			},
			// {
			// 	path: "list",
			// 	element: <CompanyList />,
			// },
			// {
			// 	path: "company-detail",
			// 	element: <CompanyDetail />,
			// },
			{
				path: "product",
				element: <ProductIntro />,
			},
			{
				path: "service",
				element: <ServiceIntro />,
			},
			{
				path: "pricing",
				element: <Pricing />,
			},
			{
				path: "news",
				element: <News />,
			},
			{
				// 路径式路由，每篇文章一个可预渲染、可进 sitemap 的独立 URL。
				// 旧的 /new-detail?articleId=N 是 query 参数形式，无法逐篇预渲染，
				// 爬虫拿到的只有空壳 —— 而正文恰恰是最容易被 AI 引用的内容。
				path: "news/:articleId",
				element: <NewsDetail />,
			},
			{
				// 兼容外部可能已存在的旧链接，跳转到新路径
				path: "new-detail",
				element: <NewsDetailLegacyRedirect />,
			},
			{
				path: "about",
				element: <AboutUs />,
			},
			{
				// 资源中心（GEO 站内文章）。内容源在 src/data/insights/，构建期进预渲染产物。
				path: "insights",
				element: <Insights />,
			},
			{
				// 路径式路由，每篇一个可预渲染、可进 sitemap 的独立 URL。
				// slug 由内容源的文件名决定；未命中的 slug 渲染提示页而非抛错
				// —— 预渲染时任一页面抛错会让 react-snap 整体退出。
				path: "insights/:slug",
				element: <InsightDetail />,
			},
			{
				path: "faq",
				element: <FAQ />,
			},
			{
				path: "privacy",
				element: <Privacy lang="zh" />,
			},
			{
				path: "privacy-en",
				element: <Privacy lang="en" />,
			},
			{
				path: "not-allowed",
				element: <NotAllowed />,
			},
			{
				path: "*",
				element: <NotFound />,
			},
		],
	},
	{
		path: "/login",
		element: <Login />,
	},
	{
		path: "/register",
		element: <Register />,
	},
	{
		path: "/application",
		element: <Application />,
	},
];

export default routes;
